import { render, staticRenderFns } from "./DonutChart70.vue?vue&type=template&id=71d8bee3&scoped=true&"
import script from "./DonutChart70.vue?vue&type=script&lang=js&"
export * from "./DonutChart70.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8bee3",
  null
  
)

export default component.exports